/* eslint-disable no-bitwise */

import moment from 'moment'


/**
 * Transform a string to capitalize it
 * @param {String} string - The string to capitalize
 * @returns {String} The capitalized string
 */
export const capitalize = (string = '') => {
  return `${string.charAt(0).toUpperCase()}${string.substring(1).toLowerCase()}`
}


/**
 * Check if the current stage is production
 * @returns {Boolean} True if the current stage is production
 */
export const isProduction = process.env.NODE_ENV === 'production'


export const truncateString = (string, length = 20) => {
  if (string.length > length) {
    return `${string.substring(0, length)}...`
  }

  return string
}

export const uuid = () => {
  let dt = Date.now()
  const uuidGenerated = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (dt + Math.random() * 16) % 16 | 0
    dt = Math.floor(dt / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })

  return uuidGenerated
}

export const getFullName = (user) => {
  return truncateString(`${capitalize(user.firstname)} ${capitalize(user.lastname)}`)
}


/**
 * Create a CSV File
 * @param {Array<String>} header - Header
 * @param {Array<*>} rows - Rows
 * @returns {String} The CSV File
 */
export const createCSV = (header, rows, title = 'exports') => {
  const stringify = text => (`${text}` || '').replace(/[\n;]/gi, ' ')
  const csv = `data:text/csv;charset=utf-8,\uFEFF${[header.map(stringify).join(';')].concat(rows.map(r => r.map(stringify).join(';')).join('\n')).join('\n')}`
  const encodedUri = encodeURI(csv)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', `${title}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


/**
 * Reverse a constant to have the key corresponding of the value
 * @param {*} constant - The constant (generally provided by the constant file)
 * @param {*} index - The index value of the constant
 * @returns {String} The key of the constant corresponding of the value
 */
export const getConstantKey = (constant, index) => {
  return Object.keys(constant).find(k => constant[k] === index)
}


export const getFolioPicture = (folio, onlyBig) => {
  const thumbnail = folio.medium || folio.thumbnail
  const big = folio.original || folio.picture

  return onlyBig ? big : thumbnail || big
}

export const formatDate = (date, format = 'DD/MM/YYYY HH:mm') => {
  if (!date) {
    return ''
  }

  const currentDate = date.toDate ? moment(date.toDate()) : moment(date)

  return currentDate.format(format)
}


export const dispatchRequest = async (dispatch, type, request, optionalParameters = {}) => {
  dispatch({ type })

  try {
    const data = await request

    return dispatch({
      data,
      ...optionalParameters,
      type: `${type}_SUCCESS`,
    })
  } catch (err) {
    return dispatch({
      type: `${type}_ERROR`,
      message: err.message,
    })
  }
}
